import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { App } from './app';
import { createQueryClient } from './api/query-client';
import { routes } from './routes';
// Typefaces (self-hosted, OFL-1.1): IBM Plex Sans for all text, in the four weights the UI uses,
// and IBM Plex Mono for identifiers and account numbers.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-sans/latin-700.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App queryClient={createQueryClient()} router={createBrowserRouter(routes)} />
  </StrictMode>,
);
